export function LogoMark({ className = "h-9 w-9" }) {
    return (
        <img
            src="/logo.png"
            alt="Logo Sconti Incredibili"
            className={`rounded-full ${className}`}
            width={64}
            height={64}
        />
    );
}

export default function Logo({ light = false, className = "" }) {
    return (
        <span className={`inline-flex items-center gap-2.5 ${className}`}>
            <img
                src="/logo.png"
                alt="Logo Sconti Incredibili"
                className={`h-10 w-10 rounded-full ${light ? "ring-1 ring-white/20" : "ring-1 ring-ink/10"}`}
                width={64}
                height={64}
            />
            <span
                className={`font-display text-lg font-semibold leading-none tracking-tight ${
                    light ? "text-white" : "text-ink"
                }`}
            >
                Sconti&nbsp;<span className="font-bold text-telegram">Incredibili</span>
            </span>
        </span>
    );
}
